<script lang="ts">
  import { onMount } from "svelte";
  import List from "../../../components/List/List.svelte";
  import Review from "../../../components/Review/Review.svelte";
  import Title from "../../../components/Title/Title.svelte";
  import Subtitle from "../../../components/Subtitle/Subtitle.svelte";
  import ComponentContainer from "../../../components/ComponentContainer/ComponentContainer.svelte";

  onMount(async () => {
    window.Superwall.configure({
      navBackgroundColor: "#FFFFFF",
      navBlur: "false",
      navCenter: "hide",
      navLeft: "text",
      navRight: "text",
      navPosition: "inline",
      hideProducts: "true",
      paywallBackgroundColor: "#404040",
      backgroundColor: "#FFFFFF",
      foregroundColor: "#000000",
      buttonBackgroundColor: "#FFFFFF",
      productBackgroundColor: "rgba(255,255,255,0.9)",
      borderColor: "rgba(0,0,0,0.4)",
      footerDivider: "hide",
      footer: "compact",
      autoAdjustContentAlignment: "true",
      contentAlignment: "bottom",
      brandColor: "#F13149",
      purchaseRadius: "100px",
    });
  });
</script>

<main>
  <div id="paywallContainer">
    <div id="contentContainer">
      <!-- svelte-ignore a11y-missing-attribute -->
      <img
        class="bg"
        data-pw-namespace="background"
        src="../public/assets/blur-bg.jpeg"
      />
      <Review
        container={{
          textColor: "#FFFFFF",
          card: true,
          backgroundColor: "var(--sw-foreground-color-20)",
          noMargin: true,
        }}
      />
    </div>
    <div id="cardContainer">
      <div data-pw-namespace="logo wrapper" class="logo-container">
        <!-- svelte-ignore a11y-missing-attribute -->
        <img class="logo" src="../public/assets/ngl/logo.png" />
      </div>
      <List
        childrenContainer={{ noMargin: true }}
        settings={{
          horizontal: true,
          snap: true,
          indicatorBottomPadding: false,
        }}
      >
        <ComponentContainer tag={"card"}>
          <!-- svelte-ignore a11y-missing-attribute -->
          <img class="hero" src="../public/assets/ngl/messages.png" />
          <Title
            settings={{ type: "h2" }}
            container={{ lightMargin: true, noPadding: true }}
          />
          <Subtitle container={{ lightMargin: true, noPadding: true }} />
        </ComponentContainer>
        <ComponentContainer tag={"card"}>
          <!-- svelte-ignore a11y-missing-attribute -->
          <img class="hero" src="../public/assets/ngl/games.png" />
          <Title
            settings={{ type: "h2" }}
            container={{ lightMargin: true, noPadding: true }}
          />
          <Subtitle container={{ lightMargin: true, noPadding: true }} />
        </ComponentContainer>
      </List>
    </div>

    <div id="purchaseContainer">
      <!-- <p></p> -->
    </div>
  </div>
</main>

<style>
  img.bg {
    position: fixed;
    top: 0px;
    width: calc(100% + 2 * var(--sw-container-padding));
    left: 50%;
    transform: translate(-50%, 0px);
    opacity: 0.5;
  }

  .logo-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img.logo {
    height: 35px;
    margin-left: auto;
    margin-right: auto;
    flex-shrink: 0;
  }

  img.hero {
    height: 111px;
    margin: var(--sw-container-padding) 0px;
  }

  #contentContainer {
    height: 100%;
    pointer-events: none;
    overflow-y: hidden;
  }
</style>
